import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import Table from "../../../../Componets/Table";
import { toast } from "react-toastify";
import tables from "../../../../Data/Tables/Settings/Users/tables";
import headers from "../../../../Data/Tables/Settings/Users/headers";
import users from "../../../../Data/users.json";
import roles from "../../../../Data/roles.json";
import Status from "../../../../Componets/Status";
import ActionButton from "../../../../Componets/Buttons/action";
import { get_all_users, promote_to_superadmin, demote_from_superadmin } from "../../../../Controllers/Settings/Users";
import Loadercomponent from "../../../../Componets/Loader";


const UsersTable = () => {
  // let header = headers;
  let head = tables;

  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState();
  const [header, setHeader] = useState(headers);

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });

  const paginationdata = (data) => {
    let headerdata = {};
    headers?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      sort: headerdata?.sort,
      unit: headerdata?.unit,
      category: headerdata?.category,
      brand: headerdata?.brand,
      type: headerdata?.type,
      status: headerdata?.status,
    });
  };

  const promoteUser = async (id) => {
    const res = await promote_to_superadmin({ id: id });

    if (res?.status) {
      toast.success(res?.message);
      fetchData();
    } else {
      toast.error(res?.message);
    }
  };

  const demoteUser = async (id, role) => {
    const res = await demote_from_superadmin({ id, role });

    if (res?.status) {
      toast.success(res?.message);
      fetchData();
    } else {
      toast.error(res?.message);
    }
  };

  const formdata = (data) => {
    let page = data?.search ? pagination?.currentPage : 1;

    fetchData({
      ...data,
      currentPage: page,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const actiondata = (data) => {
    let headerdata = {};
    headers?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      sort: headerdata?.sort,
      unit: headerdata?.unit,
      category: headerdata?.category,
      brand: headerdata?.brand,
      type: headerdata?.type,
      status: headerdata?.status,
      currentPage: pagination?.currentPage,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        product: tabledata?.product,
        date: tabledata?.date,
        type: tabledata?.type,
        status: tabledata?.status,
        page: tabledata?.currentPage,
      };

      const users = await get_all_users(data);
      if (users?.status) {
        let data = [];

        users?.data?.map((value, index) => {
          data?.push({
            // path: `/app/settings/user/view/${value?._id}`,
            Name: value?.name,
            Role: value?.role?.name,
            Email: value?.email,
            Phone: value?.phone,
            Status: <Status status={value?.status} />,
            Action: (
              <ActionButton
                edit={`/app/settings/users/edit/${value?._id}`}
                id={value?._id}
                /* api="delete-user" */
                actiondata={actiondata}
                promote={true}
                isSuperAdmin={value?.role?.name === "SUPERADMIN"}
                onPromote={promoteUser}
                onDemote={demoteUser}
                headers={header}
              />
            ),
          });
        });

        setPagination({
          currentPage: users?.data?.currentPage,
          totalCount: users?.data?.totalCount,
          totalPages: users?.data?.totalPages,
        });

        setBody(data);
        setLoader(false);
      } else {
        toast?.error(users?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Table
          head={tables}
          body={body}
          pagination={pagination}
          paginationdata={paginationdata}
        />
      </Loadercomponent>
    </Header>
  );
};

export default UsersTable;
